
import { Component, Prop, Vue } from "vue-property-decorator";
import Notification from "@/models/Notification";

@Component
export default class NotificationTemplate extends Vue {
  @Prop() notification!: Notification;
}
